// extracted by mini-css-extract-plugin
export default {"container":"_3H4X","card":"vOI-","appear":"VyP7","titleContainer":"_2XXl","title":"_1-3W","subtitle":"_1H8m","button":"Xn2V","buttons":"_2njT","content":"_svd"};